export enum ActionPermission {
  DENY = -10,
  MAYBE = 0,
  ALLOWED = 10,
}

export type ActionPermissionsHash = { [action: number]: ActionPermission };

export enum ResourceAccessLevel {
  NONE = 0,
  QUERY = 10,
  READ,
  UPDATE,
  CREATE,
  DELETE,
  ADMIN,
}
export type ResourceAccessHash = { [resource: string]: ResourceAccessLevel };
